@for (menu of parentMenu; track menu) {
  <div class="menu-item">
    @if (menu.routerLink && !menu.hasSubMenu) {
      <a mat-button
        fxLayout="row" fxLayoutAlign="start center"
        [routerLink]="[menu.routerLink]" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
        (click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
        <span class="menu-title">{{ menu.title | translate }}</span>
      </a>
    }
    @if (menu.href && !menu.subMenu) {
      <a mat-button
        fxLayout="row" fxLayoutAlign="start center"
        [attr.href]="menu.href || ''" [attr.target]="menu.target || ''"
        (click)="onClick(menu.id)" [id]="'menu-item-'+menu.id">
        <span class="menu-title">{{ menu.title | translate }}</span>
      </a>
    }
    @if (menu.hasSubMenu) {
      <a
        fxLayout="row" fxLayoutAlign="start center" #menuTitle
        [id]="'menu-item-'+menu.id">
        <table>
          <tr>
            @if (menu.routerLink == null) {
              <td><span style="display: block; z-index: 999; padding: 0em 1em;"  class="menu-title">{{ menu.title | translate }}</span></td>
            }
            <td>@if (menu.routerLink != null) {
              <a [routerLink]="[menu.routerLink]"><span style="display: block; z-index: 999; padding: 0em 1em;"  class="menu-title">{{ menu.title | translate }}</span></a>
            }</td>
            <td>@if (isExpanded) {
              <mat-icon (click)="onClick($event,menu.id)">keyboard_arrow_down</mat-icon>
            }</td>
            <td>@if (!isExpanded) {
              <mat-icon (click)="onClick($event,menu.id)">keyboard_arrow_left</mat-icon>
            }</td>
          </tr>
        </table>
      </a>
    }
    @if (menu.hasSubMenu) {
      <div class="sub-menu" [id]="'sub-menu-'+menu.id">
        <app-sidenav-menu [menuItems]="menuItems" [menuParentId]="menu.id"></app-sidenav-menu>
      </div>
    }
  </div>
}
